import React from "react";
import LegalLayout from "../components/site/LegalLayout";
import { COMPANY } from "../data/site";

export default function Disclaimer() {
  return (
    <LegalLayout title="Disclaimer" eyebrow="Legal" testId="disclaimer-page">
      <p>
        The information contained on the JayesPay website and mobile
        application (collectively, the “Platform”), operated by{" "}
        <strong>{COMPANY.legalName}</strong> (CIN: {COMPANY.cin}), is provided
        on an “as is” basis for general informational and service-enabling
        purposes only.
      </p>

      <h2>1. No Financial Advice</h2>
      <p>
        Nothing on the Platform constitutes financial, investment, legal, tax or
        professional advice. Services such as recharges, bill payments, PAN
        applications, banking correspondence (BC), recurring deposits and other
        partner-bank or partner-utility products are facilitated through
        regulated third parties. {COMPANY.name} acts solely as a technology
        facilitator.
      </p>

      <h2>2. Third-Party Services & Partners</h2>
      <p>
        Several services on the Platform — including but not limited to NSDL,
        UTIITSL, telecom operators, DTH operators, electricity & gas billers,
        insurers, lenders and partner banks — are owned and operated by their
        respective entities. {COMPANY.name} disclaims liability for outages,
        delays, errors or losses arising on the third-party&apos;s side.
      </p>

      <h2>3. Accuracy of Information</h2>
      <p>
        While we strive to keep information accurate and up-to-date, we make no
        representations or warranties of any kind, express or implied, about
        the completeness, accuracy, reliability or availability of any content,
        plans, commission rates or features described.
      </p>

      <h2>4. Retailer Responsibility</h2>
      <p>
        Retailers using the Platform are responsible for verifying transaction
        details (customer info, amounts, due dates) before confirming any
        payment. {COMPANY.name} is not liable for losses arising from incorrect
        details entered by retailers or their customers.
      </p>

      <h2>5. External Links</h2>
      <p>
        The Platform may contain links to external sites that are not operated
        by us. We have no control over the content or privacy practices of
        those sites and accept no responsibility for them.
      </p>

      <h2>6. Changes</h2>
      <p>
        We reserve the right to amend this disclaimer at any time. Continued use
        of the Platform after changes constitutes acceptance of the revised
        disclaimer.
      </p>

      <h2>7. Contact</h2>
      <p>
        For questions about this disclaimer, write to us at{" "}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> or call{" "}
        {COMPANY.phone}.
      </p>
    </LegalLayout>
  );
}
